import { GalleryDeveloperSticky } from './gallery-developer-sticky';

export default GalleryDeveloperSticky;
